import axiosInstance from "./axiosInstance";
import {
  buildLoyaltyCartItems,
  normalizeLoyaltyQuote,
  normalizeLoyaltySettings,
  normalizeLoyaltySummary,
  normalizeLoyaltyTransactions,
  toNonNegativeInteger,
} from "../utils/loyalty";

const publishSettings = (settings) => {
  window.dispatchEvent(new CustomEvent("loyalty-settings-updated", { detail: settings }));
  return settings;
};

export const getLoyaltySettings = async ({ signal } = {}) => {
  const { data } = await axiosInstance.get("/loyalty/settings", { signal });
  return publishSettings(normalizeLoyaltySettings(data));
};

export const getMyLoyalty = async ({ signal } = {}) => {
  const { data } = await axiosInstance.get("/loyalty/me", { signal });
  return normalizeLoyaltySummary(data);
};

export const getMyLoyaltyTransactions = async (
  { page = 1, limit = 10 } = {},
  { signal } = {},
) => {
  const normalizedPage = Math.max(1, toNonNegativeInteger(page));
  const normalizedLimit = Math.max(1, toNonNegativeInteger(limit));
  const { data } = await axiosInstance.get("/loyalty/me/transactions", {
    params: { page: normalizedPage, limit: normalizedLimit },
    signal,
  });
  return normalizeLoyaltyTransactions(data, normalizedPage);
};

export const getLoyaltyQuote = async (
  { cartItems = [], requestedBonusKopecks = 0 } = {},
  { signal } = {},
) => {
  const payload = {
    cartItems: buildLoyaltyCartItems(cartItems),
    requestedBonusKopecks: toNonNegativeInteger(requestedBonusKopecks),
  };
  const { data } = await axiosInstance.post("/loyalty/quote", payload, {
    signal,
  });
  const quote = normalizeLoyaltyQuote(data);
  publishSettings(quote.settings);
  return quote;
};

